import { ErrorBanner } from 'shared/ui/error-banner';
import { Period } from 'entities/period-picker/types';
import { PeriodPicker } from 'entities/period-picker/period-picker';
import { getCurrentPeriod } from 'entities/period-picker/period.helpers';
import { InputSize } from 'shared/layout/constants';
import { ReactNode } from 'react';
import { useCashFlowPeriods } from './cash-flow-period.hook';

interface Props {
  title?: ReactNode;
  selectedPeriod?: Period;
  onSelect: (period: Period) => void;
  size?: InputSize;
  readOnly?: boolean;
  withQueryParams?: boolean;
}

export const CashFlowPeriodPicker = ({
  size = 'small',
  selectedPeriod = getCurrentPeriod(),
  onSelect,
  readOnly = false,
  withQueryParams = false
}: Props) => {
  const { cashFlowPeriods, isLoading, error } = useCashFlowPeriods();
  if (error) {
    return <ErrorBanner errorMessage={error} />;
  }

  return (
    <>
      {!isLoading && (
        <PeriodPicker
          size={size}
          periods={cashFlowPeriods}
          onSelect={onSelect}
          selectedPeriod={selectedPeriod}
          isLoading={isLoading}
          withQueryParams={withQueryParams}
          withAllYearOption={true}
          readOnly={readOnly}
        />
      )}
    </>
  );
};
